import React, { useEffect, useState } from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48552680259801:1';
const CHECKOUT_PRO = 'https://academiaholisticaargentina.com/cart/48552681668825:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [selected, setSelected] = useState<'pro' | 'base'>('pro');
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const checkoutUrl = selected === 'pro' ? CHECKOUT_PRO : CHECKOUT_BASE;
  const ctaLabel = selected === 'pro' ? '→ QUIERO EL CÓDIGO + PROTOCOLO DE SOBERANÍA TOTAL' : '→ QUIERO MI CÓDIGO';
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-[#C9A96E]/10" data-id="element-211">
      <div className="container mx-auto max-w-4xl" data-id="element-212">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-213">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5ECD7] mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-214">
            ⏰ PRECIO DE RELANZAMIENTO — CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-215">
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-216">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-217">hs</span>
            <span className="text-[#C9A96E] text-2xl font-bold animate-pulse" data-id="element-218">
              :
            </span>
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-219">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-220">min</span>
            <span className="text-[#C9A96E] text-2xl font-bold animate-pulse" data-id="element-221">
              :
            </span>
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-222">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-223">seg</span>
          </div>

          <p className="text-[#C4856A] font-bold text-lg mb-6" data-id="element-224">
            ⚠️ Después sube. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-[#2D1B1B] p-4 rounded-xl border border-[#C9A96E]/20 shadow-lg" data-id="element-225">
            <div className="flex justify-between text-xs font-bold mb-2" data-id="element-226">
              <span className="text-[#F5ECD7]" data-id="element-227">
                🔴 Cupos al precio de relanzamiento
              </span>
              <span className="text-[#C9A96E]" data-id="element-228">68%</span>
            </div>
            <div className="w-full bg-[#1C1410] rounded-full h-2.5" data-id="element-229">
              <div className="bg-gradient-to-r from-[#8B2635] to-[#C9A96E] h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-230"></div>
            </div>
            <p className="text-[#D4A5A5] text-[10px] mt-2 text-center" data-id="element-231">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-232">
          <div className="text-center mb-6" data-id="element-233">
            <h3 className="text-2xl font-bold text-[#F5ECD7]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-234">
              ELEGÍ TU CÓDIGO
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 items-stretch" data-id="element-235">
            {/* Pro Card */}
            <div onClick={() => setSelected('pro')} className={`relative bg-gradient-to-b from-[#2D1B1B] to-[#1C1410] rounded-xl p-3.5 sm:p-4 flex flex-col z-10 cursor-pointer transition-all duration-300 ${selected === 'pro' ? 'border-2 border-[#C9A96E] shadow-[0_0_40px_rgba(201,169,110,0.2)]' : 'border-2 border-[#C9A96E]/20 opacity-70 hover:opacity-90'}`} data-id="element-236">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'pro' ? 'border-[#C9A96E] bg-[#C9A96E]' : 'border-[#F5ECD7]/30 bg-transparent'}`} data-id="element-237">
                {selected === 'pro' && <CheckIcon className="w-3 h-3 text-[#1C1410]" strokeWidth={3} data-id="element-238" />}
              </div>

              <div className="mb-2" data-id="element-239">
                <span className="bg-gradient-to-r from-[#C9A96E] to-[#C4856A] text-[#1C1410] text-[9px] font-bold px-2.5 py-0.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-240">
                  ⭐ RECOMENDADO
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#F5ECD7] mb-1 pr-6" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-241">
                🏆 EL CÓDIGO + PROTOCOLO DE SOBERANÍA TOTAL ⭐
              </h3>
              <p className="text-[#C9A96E] font-bold text-xs mb-2" data-id="element-242">
                6 Tomos + 6 Bonos + Guía Maestra de Blindaje Emocional
              </p>

              <p className="text-[#FAF3E8] text-[10px] leading-snug mb-3" data-id="element-243">
                <span className="text-[#F5ECD7] font-bold" data-id="element-244">Ideal para:</span>{' '}
                Liberar el árbol, blindar la nueva identidad y sostener el
                cambio a largo plazo
              </p>

              <div className="mt-auto" data-id="element-245">
                <p className="text-[#D4A5A5] text-xs line-through" data-id="element-246">$89.000</p>
                <p className="text-3xl sm:text-4xl font-extrabold text-[#C9A96E] leading-none" style={{
                textShadow: '0 0 30px rgba(201,169,110,0.4)'
              }} data-id="element-247">
                  $27.990{' '}
                  <span className="text-base font-bold text-[#F5ECD7]" data-id="element-248">
                    ARS
                  </span>
                </p>
              </div>
            </div>

            {/* Base Card */}
            <div onClick={() => setSelected('base')} className={`relative bg-[#2D1B1B] rounded-xl p-3.5 sm:p-4 flex flex-col cursor-pointer transition-all duration-300 ${selected === 'base' ? 'border-2 border-[#C9A96E] shadow-[0_0_40px_rgba(201,169,110,0.2)]' : 'border-2 border-[#C9A96E]/20 opacity-70 hover:opacity-90'}`} data-id="element-249">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'base' ? 'border-[#C9A96E] bg-[#C9A96E]' : 'border-[#F5ECD7]/30 bg-transparent'}`} data-id="element-250">
                {selected === 'base' && <CheckIcon className="w-3 h-3 text-[#1C1410]" strokeWidth={3} data-id="element-251" />}
              </div>

              <div className="mb-2 pt-3" data-id="element-252"></div>

              <h3 className="text-base sm:text-lg font-bold text-[#F5ECD7] mb-1 pr-6" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-253">
                📘 EL CÓDIGO DE LA HIJA LIBRE
              </h3>
              <p className="text-[#F5ECD7] font-bold text-xs mb-2" data-id="element-254">
                6 Tomos + 6 Bonos
              </p>

              <p className="text-[#FAF3E8] text-[10px] leading-snug mb-3" data-id="element-255">
                <span className="text-[#F5ECD7] font-bold" data-id="element-256">Ideal para:</span>{' '}
                Identificar, trabajar y liberar los patrones heredados del árbol
                genealógico
              </p>

              <div className="mt-auto" data-id="element-257">
                <p className="text-[#D4A5A5] text-xs line-through" data-id="element-258">$69.000</p>
                <p className="text-3xl sm:text-4xl font-extrabold text-[#F5ECD7] leading-none" style={{
                textShadow: '0 0 30px rgba(245,236,215,0.15)'
              }} data-id="element-259">
                  $19.990{' '}
                  <span className="text-base font-bold text-[#FAF3E8]" data-id="element-260">
                    ARS
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Single CTA Button — sticky on mobile */}
          <div className="mt-6 max-w-xl mx-auto sticky bottom-4 z-30" data-id="element-261">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full block py-3.5 md:py-5 rounded-xl text-[#F5ECD7] hover:text-[#1C1410] font-bold text-xs sm:text-base tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_0_30px_rgba(139,38,53,0.4)] hover:shadow-[0_0_40px_rgba(201,169,110,0.6)] hover:-translate-y-1 bg-[#8B2635] hover:bg-[#C9A96E] border border-[#8B2635] hover:border-[#C9A96E]" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-262">
              {ctaLabel}
            </a>
          </div>
        </div>
      </div>
    </section>;
}